import React, { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { Host } from '../App';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../ShippingData.css';

function ReturnParts() {
  const [poNo, setPoNo] = useState([]);
  const [selectedPO, setSelectedPO] = useState('');
  const [partOptions, setPartOptions] = useState([]);
  const [returnRows, setReturnRows] = useState([
    {
      id: 1,
      PO_NO: '',
      PART_NO: '',
      PO_SHIP_DATE: '',
      PART_DESCRIPTION: '',
      CUSTOMER: '',
      ACTUAL_SHIP_DATE: '',
      QTY_SHIPPED: '',
      COMMENTS: '',
      RET_QTY: '',
      ISSUE: '',
      RET_DATE: new Date().toISOString().slice(0, 10),
      RET_TYPE: '',
      UNIT_PRICE: '',
      RET_SHIP_DATE: new Date().toISOString().slice(0, 10)
    }
  ]);

  // New state for returned parts table
  const [returnedParts, setReturnedParts] = useState([]);
  const [filteredParts, setFilteredParts] = useState([]);
  const [filters, setFilters] = useState({
    PO_NO: '',
    PART_NO: '',
    CUSTOMER: '',
    RET_DATE: ''
  });
  const [editingRow, setEditingRow] = useState(null);
  const [editData, setEditData] = useState({});

  const token = window.localStorage.getItem("acessToken");
  const User = JSON.parse(window.localStorage.getItem("Name"));

  // Fetch all PO numbers on component mount
  useEffect(() => {
    Axios.get(`https://${Host}/api/get/pono/${token}`)
      .then((response) => {
        setPoNo(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PO numbers:", error);
      });
  }, [token]);

  // Fetch returned parts data
  useEffect(() => {
    fetchReturnedParts();
  }, [token]);

  // Replace the fetchReturnedParts function and its useEffect with this:

  const fetchReturnedParts = useCallback(() => {
    Axios.get(`http://localhost:3001/api/return?token=${token}`)
      .then((response) => {
        setReturnedParts(response.data);
        // ❌ Removed: setFilteredParts(response.data) — filter useEffect handles this
      })
      .catch((error) => {
        console.error("Error fetching returned parts:", error);
      });
  }, [token]); // stable reference — only recreated if token changes

  useEffect(() => {
    fetchReturnedParts();
  }, [fetchReturnedParts]); // ✅ now safe — won't re-fire on every render

  // Apply filters
  useEffect(() => {
    let filtered = returnedParts;

    if (filters.PO_NO) {
      filtered = filtered.filter(part =>
        part.PO_NO.toLowerCase().includes(filters.PO_NO.toLowerCase())
      );
    }
    if (filters.PART_NO) {
      filtered = filtered.filter(part =>
        part.PART_NO.toLowerCase().includes(filters.PART_NO.toLowerCase())
      );
    }
    if (filters.CUSTOMER) {
      filtered = filtered.filter(part =>
        part.CUSTOMER.toLowerCase().includes(filters.CUSTOMER.toLowerCase())
      );
    }
    if (filters.RET_DATE) {
      filtered = filtered.filter(part =>
        part.RET_DATE && part.RET_DATE.slice(0, 10) === filters.RET_DATE
      );
    }

    setFilteredParts(filtered);
  }, [filters, returnedParts]);

  // Calculate total unit price
  const totalUnitPrice = filteredParts.reduce((sum, part) => {
    return sum + (parseFloat(part.UNIT_PRICE) * parseInt(part.RET_QTY) || 0);
  }, 0);

  // Handle filter change
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  // Clear filters
  const clearFilters = () => {
    setFilters({
      PO_NO: '',
      PART_NO: '',
      CUSTOMER: '',
      RET_DATE: ''
    });
  };

  // Start editing a row
  const startEdit = (part, index) => {
    setEditingRow(index);
    setEditData({
      PO_NO: part.PO_NO,
      PART_NO: part.PART_NO,
      RET_QTY: part.RET_QTY,
      ISSUE: part.ISSUE,
      RET_DATE: part.RET_DATE ? part.RET_DATE.slice(0, 10) : '',
      RET_TYPE: part.RET_TYPE,
      UNIT_PRICE: part.UNIT_PRICE || '',
      RET_SHIP_DATE: part.RET_SHIP_DATE ? part.RET_SHIP_DATE.slice(0, 10) : ''
    });
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingRow(null);
    setEditData({});
  };

  // Save edited row
  const saveEdit = () => {
    // Validation
    if (!editData.RET_QTY || !editData.ISSUE || !editData.RET_DATE || !editData.RET_TYPE) {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '18px' }
      });
      return;
    }

    Axios.put(`http://localhost:3001/api/return/update`, {
      PO_NO: editData.PO_NO,
      PART_NO: editData.PART_NO,
      RET_QTY: editData.RET_QTY,
      ISSUE: editData.ISSUE,
      RET_DATE: editData.RET_DATE,
      RET_TYPE: editData.RET_TYPE,
      UNIT_PRICE: editData.UNIT_PRICE || '0',
      RET_SHIP_DATE: editData.RET_SHIP_DATE,
      token: token
    })
      .then((response) => {
        toast.success("Return updated successfully!", {
          autoClose: 2000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '18px' }
        });
        fetchReturnedParts();
        setEditingRow(null);
        setEditData({});
      })
      .catch((error) => {
        console.error("Update error:", error);
        toast.error(error.response?.data?.message || "Error updating return", {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '18px' }
        });
      });
  };

  // Handle edit input change
  const handleEditChange = (field, value) => {
    setEditData(prev => ({ ...prev, [field]: value }));
  };

  // Fetch parts for selected PO
  useEffect(() => {
    if (selectedPO) {
      Axios.get(`https://${Host}/api/Shipping/search/${JSON.stringify(selectedPO)},{},2000-01-01,2099-12-31,{},0,${token},{}`)
        .then((response) => {
          setPartOptions(response.data);
        })
        .catch((error) => {
          console.error("Error fetching parts:", error);
        });
    } else {
      setPartOptions([]);
    }
  }, [selectedPO, token]);

  // Handle PO selection
  const handlePOChange = (value) => {
    setSelectedPO(value);
    // Reset all rows when PO changes
    setReturnRows([
      {
        id: 1,
        PO_NO: value,
        PART_NO: '',
        PO_SHIP_DATE: '',
        PART_DESCRIPTION: '',
        CUSTOMER: '',
        ACTUAL_SHIP_DATE: '',
        QTY_SHIPPED: '',
        COMMENTS: '',
        RET_QTY: '',
        ISSUE: '',
        RET_DATE: new Date().toISOString().slice(0, 10),
        RET_TYPE: '',
        UNIT_PRICE: '',
        RET_SHIP_DATE: new Date().toISOString().slice(0, 10)
      }
    ]);
  };

  // Handle part selection for a specific row
  const handlePartChange = (rowId, partNo) => {
    const selectedPart = partOptions.find(part => part.PART_NO === partNo);

    if (selectedPart) {
      setReturnRows(prevRows =>
        prevRows.map(row =>
          row.id === rowId
            ? {
              ...row,
              PART_NO: selectedPart.PART_NO,
              PO_SHIP_DATE: selectedPart.PO_SHIP_DATE.slice(0, 10),
              PART_DESCRIPTION: selectedPart.PART_DESCRIPTION,
              CUSTOMER: selectedPart.CUSTOMER,
              ACTUAL_SHIP_DATE: selectedPart.PO_DATE ? selectedPart.PO_DATE.slice(0, 10) : '',
              QTY_SHIPPED: selectedPart.QTY || '',
              COMMENTS: selectedPart.COMMENTS || ''
            }
            : row
        )
      );
    }
  };

  // Handle input change for return-specific fields
  const handleInputChange = (rowId, field, value) => {
    setReturnRows(prevRows =>
      prevRows.map(row =>
        row.id === rowId ? { ...row, [field]: value } : row
      )
    );
  };

  // Add new row
  const addRow = () => {
    if (returnRows.length >= 15) {
      toast.warning("Maximum 15 rows allowed", {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '18px' }
      });
      return;
    }

    if (!selectedPO) {
      toast.warning("Please select a PO first", {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '18px' }
      });
      return;
    }

    const newId = Math.max(...returnRows.map(r => r.id), 0) + 1;
    setReturnRows([
      ...returnRows,
      {
        id: newId,
        PO_NO: selectedPO,
        PART_NO: '',
        PO_SHIP_DATE: '',
        PART_DESCRIPTION: '',
        CUSTOMER: '',
        ACTUAL_SHIP_DATE: '',
        QTY_SHIPPED: '',
        COMMENTS: '',
        RET_QTY: '',
        ISSUE: '',
        RET_DATE: new Date().toISOString().slice(0, 10),
        RET_TYPE: '',
        UNIT_PRICE: '',
        RET_SHIP_DATE: new Date().toISOString().slice(0, 10),
        NEW_PO: ''
      }
    ]);
  };

  // Remove row
  const removeRow = (rowId) => {
    if (returnRows.length === 1) {
      toast.warning("At least one row is required", {
        autoClose: 2000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '18px' }
      });
      return;
    }
    setReturnRows(prevRows => prevRows.filter(row => row.id !== rowId));
  };

  // Validate and submit
  const handleSubmit = () => {
    // Validation
    const invalidRows = returnRows.filter(row =>
      !row.PART_NO ||
      !row.RET_QTY ||
      !row.ISSUE ||
      !row.RET_DATE ||
      !row.RET_TYPE
    );

    if (invalidRows.length > 0) {
      toast.error("Please fill all required fields (Part No, Return Qty, Issue, Return Date, Return Type)", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '18px' }
      });
      return;
    }

    // Prepare data for API
    const updateData = returnRows.map(row => [
      row.PO_NO,
      row.PART_NO,
      row.PO_SHIP_DATE,
      row.PART_DESCRIPTION,
      row.CUSTOMER,
      row.ACTUAL_SHIP_DATE,
      row.QTY_SHIPPED,
      row.COMMENTS,
      row.RET_QTY,
      row.ISSUE,
      row.RET_DATE,
      row.RET_TYPE,
      row.UNIT_PRICE || '0',
      row.RET_SHIP_DATE,
      row.NEW_PO
    ]);

    // Submit to API
    Axios.post(`https://${Host}/api/return/Add_new`, {
      updateData: updateData.map((data, index) => ({
        PO_NO: data[0],
        PART_NO: data[1],
        PO_SHIP_DATE: data[2],
        PART_DESCRIPTION: data[3],
        CUSTOMER: data[4],
        ACTUAL_SHIP_DATE: data[5],
        QTY_SHIPPED: data[6],
        COMMENTS: data[7],
        RET_QTY: data[8],
        ISSUE: data[9],
        RET_DATE: data[10],
        RET_TYPE: data[11],
        UNIT_PRICE: data[12],
        RET_SHIP_DATE: data[13],
        NEW_PO: data[14]
      })),
      token: token
    })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message || "Returns added successfully!", {
            autoClose: 3000,
            position: toast.POSITION.TOP_RIGHT,
            style: { fontSize: '24px', borderRadius: '10px' }
          });

          // Reset form
          setSelectedPO('');
          setPartOptions([]);
          setReturnRows([
            {
              id: 1,
              PO_NO: '',
              PART_NO: '',
              PO_SHIP_DATE: '',
              PART_DESCRIPTION: '',
              CUSTOMER: '',
              ACTUAL_SHIP_DATE: '',
              QTY_SHIPPED: '',
              COMMENTS: '',
              RET_QTY: '',
              ISSUE: '',
              RET_DATE: new Date().toISOString().slice(0, 10),
              RET_TYPE: '',
              UNIT_PRICE: '',
              RET_SHIP_DATE: new Date().toISOString().slice(0, 10),
              NEW_PO: ''
            }
          ]);

          // Refresh the returned parts table
          fetchReturnedParts();
        }
      })
      .catch((error) => {
        console.error("Submission error:", error);
        toast.error(error.response?.data?.message || "Error submitting returns", {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '18px' }
        });
      });
  };

  return (
    <div className="MainPage_data">
      <ToastContainer />
      <div className="Container">
        <div style={{ padding: '20px' }}>
          <h2 style={{ marginBottom: '20px' }}>Add Returned Parts</h2>

          {/* PO Selection */}
          <div className="row" style={{ marginBottom: '20px' }}>
            <div className="col-md-4">
              <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Select PO Number *</label>
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="PO NO"
                list="PoNoList"
                value={selectedPO}
                onChange={(e) => handlePOChange(e.target.value)}
              />
              <datalist id="PoNoList">
                <option value=""></option>
                {poNo.map((x, index) => (
                  <option key={index} value={x.PO_NO}>{x.PO_NO}</option>
                ))}
              </datalist>
            </div>
          </div>

          {/* Return Rows Table */}
          {selectedPO && (
            <>
              <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
                <table className="table table-bordered">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th style={{ minWidth: '150px' }}>Part No *</th>
                      <th style={{ minWidth: '120px' }}>PO Ship Date</th>
                      <th style={{ minWidth: '200px' }}>Part Description</th>
                      <th style={{ minWidth: '150px' }}>Customer</th>
                      <th style={{ minWidth: '120px' }}>Actual Ship Date</th>
                      <th style={{ minWidth: '100px' }}>Qty Shipped</th>
                      <th style={{ minWidth: '200px' }}>Comments</th>
                      <th style={{ minWidth: '120px' }}>Return Qty *</th>
                      <th style={{ minWidth: '200px' }}>Issue *</th>
                      <th style={{ minWidth: '120px' }}>Return Date *</th>
                      <th style={{ minWidth: '150px' }}>Return Type *</th>
                      <th style={{ minWidth: '120px' }}>Unit Price</th>
                      <th style={{ minWidth: '140px' }}>Return Ship Date</th>
                      <th style={{ minWidth: '140px' }}>New PO</th>
                      <th style={{ minWidth: '80px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {returnRows.map((row) => (
                      <tr key={row.id}>
                        {/* Part Number - Dropdown */}
                        <td>
                          <select
                            className="form-control"
                            value={row.PART_NO}
                            onChange={(e) => handlePartChange(row.id, e.target.value)}
                          >
                            <option value="">Select Part</option>
                            {partOptions.map((part, index) => (
                              <option key={index} value={part.PART_NO}>
                                {part.PART_NO}
                              </option>
                            ))}
                          </select>
                        </td>

                        {/* Auto-filled fields (read-only) */}
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.PO_SHIP_DATE}
                            readOnly
                            style={{ backgroundColor: '#e9ecef' }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.PART_DESCRIPTION}
                            readOnly
                            style={{ backgroundColor: '#e9ecef' }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.CUSTOMER}
                            readOnly
                            style={{ backgroundColor: '#e9ecef' }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.ACTUAL_SHIP_DATE}
                            readOnly
                            style={{ backgroundColor: '#e9ecef' }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.QTY_SHIPPED}
                            readOnly
                            style={{ backgroundColor: '#e9ecef' }}
                          />
                        </td>
                        <td>
                          <textarea
                            className="form-control"
                            value={row.COMMENTS}
                            readOnly
                            style={{ backgroundColor: '#e9ecef', minHeight: '60px' }}
                          />
                        </td>

                        {/* Editable return fields */}
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.RET_QTY}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow only numbers
                              if (!/^\d*\.?\d*$/.test(value)) {
                                alert("Numbers only");
                                return;
                              }
                              handleInputChange(row.id, 'RET_QTY', e.target.value)
                            }}
                            placeholder="Enter qty"
                            min="1"
                          />
                        </td>
                        <td>
                          <textarea
                            className="form-control"
                            value={row.ISSUE}
                            onChange={(e) => handleInputChange(row.id, 'ISSUE', e.target.value)}
                            placeholder="Describe issue"
                            style={{ minHeight: '60px' }}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            value={row.RET_DATE}
                            onChange={(e) => handleInputChange(row.id, 'RET_DATE', e.target.value)}
                          />
                        </td>
                        <td>
                          <select
                            className="form-control"
                            value={row.RET_TYPE}
                            onChange={(e) => handleInputChange(row.id, 'RET_TYPE', e.target.value)}
                          >
                            <option value="">Select Type</option>
                            <option value="Credit">Credit</option>
                            <option value="Replacement">Replacement</option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.UNIT_PRICE}
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow only numbers
                              if (!/^\d*\.?\d*$/.test(value)) {
                                alert("Numbers only");
                                return;
                              }

                              handleInputChange(row.id, 'UNIT_PRICE', e.target.value)
                            }}

                            placeholder="0.00"
                            step="0.01"
                            min="0"
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            value={row.RET_SHIP_DATE}
                            onChange={(e) => handleInputChange(row.id, 'RET_SHIP_DATE', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.NEW_PO}
                            onChange={(e) => handleInputChange(row.id, 'NEW_PO', e.target.value)}
                            placeholder="Enter new PO"
                          />
                        </td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeRow(row.id)}
                            disabled={returnRows.length === 1}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Action Buttons */}
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-primary"
                    onClick={addRow}
                    disabled={returnRows.length >= 15}
                    style={{ marginRight: '10px' }}
                  >
                    Add Row ({returnRows.length}/15)
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={handleSubmit}
                  >
                    Submit Returns
                  </button>
                  <Link to="/shippingdata" style={{ marginLeft: '10px' }}>
                    <button className="btn btn-secondary">
                      Back to Shipping
                    </button>
                  </Link>
                </div>
              </div>

              {/* Helper Text */}
              <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <small>
                  <strong>Instructions:</strong>
                  <ul>
                    <li>Fields marked with * are required</li>
                    <li>Select a part number to auto-fill shipping information</li>
                    <li>You can add up to 15 return entries at once</li>
                    <li>All rows must have valid data before submission</li>
                  </ul>
                </small>
              </div>
            </>
          )}
        </div>

      </div>
      {/* Returned Parts Table */}
      <div className="Container" style={{ marginTop: '40px' }}>
        <div style={{ padding: '20px' }}>
          <h2 style={{ marginBottom: '20px' }}>All Returned Parts</h2>

          {/* Filters */}
          <div className="row" style={{ marginBottom: '20px' }}>
            <div className="col-md-3">
              <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Filter by PO No</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search PO No"
                value={filters.PO_NO}
                onChange={(e) => handleFilterChange('PO_NO', e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Filter by Part No</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search Part No"
                value={filters.PART_NO}
                onChange={(e) => handleFilterChange('PART_NO', e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Filter by Customer</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search Customer"
                value={filters.CUSTOMER}
                onChange={(e) => handleFilterChange('CUSTOMER', e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Filter by Return Date</label>
              <input
                type="date"
                className="form-control"
                value={filters.RET_DATE}
                onChange={(e) => handleFilterChange('RET_DATE', e.target.value)}
              />
            </div>
          </div>


          {/* Scrollable Table */}
          <div style={{
            maxHeight: '900px',
            overflowY: 'auto',
            overflowX: 'auto',
            border: '1px solid #dee2e6',
            borderRadius: '5px'
          }}>
            <table className="table table-bordered table-hover" style={{ marginBottom: '0' }}>
              <thead style={{
                backgroundColor: '#343a40',
                color: 'white',
                position: 'sticky',
                top: '0',
                zIndex: '1'
              }}>
                <tr>
                  <th style={{ minWidth: '120px' }}>PO No</th>
                  <th style={{ minWidth: '120px' }}>Part No</th>
                  <th style={{ minWidth: '120px' }}>PO Ship Date</th>
                  <th style={{ minWidth: '200px' }}>Part Description</th>
                  <th style={{ minWidth: '150px' }}>Customer</th>
                  <th style={{ minWidth: '130px' }}>Actual Ship Date</th>
                  <th style={{ minWidth: '100px' }}>Qty Shipped</th>
                  <th style={{ minWidth: '200px' }}>Comments</th>
                  <th style={{ minWidth: '100px' }}>Return Qty</th>
                  <th style={{ minWidth: '200px' }}>Issue</th>
                  <th style={{ minWidth: '120px' }}>Return Date</th>
                  <th style={{ minWidth: '120px' }}>Return Type</th>
                  <th style={{ minWidth: '120px' }}>Unit Price</th>
                  <th style={{ minWidth: '120px' }}>Amount</th>

                  <th style={{ minWidth: '140px' }}>Return Ship Date</th>
                  <th style={{ minWidth: '120px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredParts.length === 0 ? (
                  <tr>
                    <td colSpan="15" style={{ textAlign: 'center', padding: '20px' }}>
                      No returned parts found
                    </td>
                  </tr>
                ) : (
                  filteredParts.map((part, index) => (
                    <tr key={index}>
                      <td>{part.PO_NO}</td>
                      <td>{part.PART_NO}</td>
                      <td>{part.PO_SHIP_DATE ? new Date(part.PO_SHIP_DATE).toLocaleDateString() : ''}</td>
                      <td>{part.PART_DESCRIPTION}</td>
                      <td>{part.CUSTOMER}</td>
                      <td>{part.ACTUAL_SHIP_DATE ? new Date(part.ACTUAL_SHIP_DATE).toLocaleDateString() : ''}</td>
                      <td>{part.QTY_SHIPPED}</td>
                      <td>
                        <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {part.COMMENTS}
                        </div>
                      </td>


                      {/* Editable Fields */}
                      {editingRow === index ? (
                        <>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={editData.RET_QTY}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!/^\d*\.?\d*$/.test(value)) {
                                  alert("Numbers only");
                                  return;
                                }
                                handleEditChange('RET_QTY', value);
                              }}
                            />
                          </td>
                          <td>
                            <textarea
                              className="form-control form-control-sm"
                              value={editData.ISSUE}
                              onChange={(e) => handleEditChange('ISSUE', e.target.value)}
                              style={{ minHeight: '60px' }}
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              value={editData.RET_DATE}
                              onChange={(e) => handleEditChange('RET_DATE', e.target.value)}
                            />
                          </td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              value={editData.RET_TYPE}
                              onChange={(e) => handleEditChange('RET_TYPE', e.target.value)}
                            >
                              <option value="">Select Type</option>
                              <option value="Credit">Credit</option>
                              <option value="Replacement">Replacement</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={editData.UNIT_PRICE}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!/^\d*\.?\d*$/.test(value)) {
                                  alert("Numbers only");
                                  return;
                                }
                                handleEditChange('UNIT_PRICE', value);
                              }}
                            />
                          </td>

                          <td>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              value={editData.RET_SHIP_DATE}
                              onChange={(e) => handleEditChange('RET_SHIP_DATE', e.target.value)}
                            />
                          </td>
                          <td>
                            <button
                              className="btn btn-success btn-sm"
                              onClick={saveEdit}
                              style={{ marginRight: '5px' }}
                            >
                              Save
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={cancelEdit}
                            >
                              Cancel
                            </button>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{part.RET_QTY}</td>
                          <td>
                            <div style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {part.ISSUE}
                            </div>
                          </td>
                          <td>{part.RET_DATE ? new Date(part.RET_DATE).toLocaleDateString() : ''}</td>
                          <td>{part.RET_TYPE}</td>
                          <td>${parseFloat(part.UNIT_PRICE || 0).toFixed(2)}</td>
                          <td>${(parseFloat(part.UNIT_PRICE || 0) * parseInt(part.RET_QTY || 0)).toFixed(2)}</td>
                          <td>{part.RET_SHIP_DATE ? new Date(part.RET_SHIP_DATE).toLocaleDateString() : ''}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => startEdit(part, index)}
                            >
                              Edit
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Total */}
          <div style={{
            marginTop: '15px',
            padding: '15px',
            backgroundColor: '#f8f9fa',
            borderRadius: '5px',
            textAlign: 'right'
          }}>
            <h4 style={{ marginBottom: '0' }}>
              Total Amount:<strong>${totalUnitPrice.toFixed(2)}</strong>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReturnParts;